import { createContext } from "react";
import { Lang } from "./i18n";

export const Context = createContext<AppContext>(defaultContext());

export interface AppContext {
    lang: Lang;
    setLang: (lang: Lang) => void;
}

function defaultContext(): AppContext {
    return {
        lang: Lang.En,
        setLang: (lang: Lang) => { }
    };
}